import Vue from 'vue';

// Store
import store from '@/app/stores/store.js';

// Constants
import { ERROR_MSG } from '@/app/constants/status-constants';

export const authApiInterceptor = (instance) => {
	// Interceptors
	instance.interceptors.request.use(config => {
		// Add token to req headers
		const authJwtToken = store.getters.getAuthToken ? store.getters.getAuthToken : store.getters.getUserToken;
		if (authJwtToken) {
			config.headers['Authorization'] = `Bearer ${authJwtToken}`;
		}
		return config;
	}, function (error) {
		return Promise.reject(error);
	});

	instance.interceptors.response.use(response =>  {
		return response;
	}, function (error) {
		// Show timeout error
		if (error.message === ERROR_MSG.TIMEOUT_EXCEEDED) {
			Vue.notify({
				group: 'notifs',
				type: 'error',
				title: ERROR_MSG.INTERNAL_ERROR_TITLE,
				text: ERROR_MSG.INTERNAL_CONNECTION_TIMEOUT,
				duration: -1,
				closeOnClick: true
			});
		}
		return Promise.reject(error);
	});
}